import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../utils/date";

interface PeriodCellProps {
  startDate?: string | null;
  endDate?: string | null;
  overdue: boolean;
}

export default function PeriodCell({ startDate, endDate, overdue }: Readonly<PeriodCellProps>) {
  const { i18n } = useTranslation();
  const format = (value?: string | null) => (value ? formatDate(value, i18n.language) : "—");

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, whiteSpace: "nowrap" }}>
      <CalendarMonthOutlinedIcon fontSize="small" color="action" />
      <Typography variant="body2">{format(startDate)}</Typography>
      <Typography variant="body2" color="text.disabled">
        /
      </Typography>
      <Typography
        variant="body2"
        color={overdue ? "error.main" : "text.primary"}
        fontWeight={overdue ? "medium" : undefined}
      >
        {format(endDate)}
      </Typography>
    </Box>
  );
}